import {checkExists} from 'external/dev_april_corgi+/js/common/asserts';

import {ActionsBuffer} from '../execution/actions_dispatcher';
import {PipeId} from '../execution/graph';
import {PSink, PipeContext, Source, walkMaterials} from '../execution/pipes';
import {DataValue, VolumeValue} from '../types/data';

export class OutputMaterialsSink extends PSink<DataValue> {
  constructor(
    id: PipeId,
    private readonly amount: Source<VolumeValue>,
    inputs: Array<Source<DataValue>>,
  ) {
    super(id, [amount, ...inputs]);
  }

  async collate(context: PipeContext): Promise<void> {
    const amount = checkExists(this.values.get(this.amount));
    amount.resolve({});
    const volume = amount.value as VolumeValue;

    const materials = [...this.values.values()].filter(
      ({source}) => source !== this.amount,
    );
    const promises = [];
    const stores: Array<Parameters<ActionsBuffer['storeMaterial']>> = [];
    for (const {value, resolve, reject} of materials) {
      promises.push(
        resolve(
          walkMaterials(value, reject, v => {
            stores.push([
              v.material,
              context.lab.plate(v.plate).well(v.well),
              volume.numberNl,
            ]);
            return {volume};
          }),
        ),
      );
    }
    await Promise.all(promises);

    for (const action of stores) {
      context.dispatcher.actor(this).storeMaterial(...action);
    }
  }
}
